<template>
    <div class="record">

        <!-- 在这里添加顶部吸顶效果 -->
        <div class="record-top-part">
            <!-- 1. 顶部搜索框 -->
            <record-top-bar></record-top-bar>
            
            <!-- 2. 记录排序菜单栏 -->
            <div class="layout-record-order-bar dsp-flex">
                <div class="layout-rob-item" v-bind:class="{'rob-item-cur-all': showAllRecord}" @click.passive="clickAll">{{curFilterData.text.slice(0, 4)}}<i class="iconfont rob-icon" v-bind:class="{'icon-up': showAllRecord, 'icon-down': !showAllRecord}"></i></div>
                <div class="layout-rob-item rob-item-name" v-bind:class="{'rob-item-cur': !showAllRecord && recordCurOrderIndex == 1}" @click.passive="clickNameOrder">名称顺序</div>
                <div class="layout-rob-item rob-item-time" v-bind:class="{'rob-item-cur': !showAllRecord && recordCurOrderIndex == 2}" @click.passive='clickCreateTime'>创建时间<i class="iconfont rob-icon" v-bind:class="{'icon-up-down': recordCurOrderIndex != 2, 'icon-up': recordCurOrderIndex == 2 && createTimeOrder == 0, 'icon-down': recordCurOrderIndex == 2 && createTimeOrder == 1}"></i></div>
                <div v-show="curFilterData.title == 'all'" class="layout-rob-item rob-item-recent" v-bind:class="{'rob-item-cur': !showAllRecord && recordCurOrderIndex == 3}" @click.passive='clickRecent'>最近浏览<i class="iconfont icon-eye rob-icon"></i></div>
            </div>

            <!-- 3. 年月日展示组件 -->
            <div v-show="!showAllRecord && recordCurOrderIndex == 1 && !noRecordData" class="layout-rl-title dsp-flex">
                <div class="layout-rlt-letter">{{recordCurFirstL}}</div>
                <div class="layout-rlt-note">
                    <div class="dsp-flex">
                        <span>年</span>
                        <span>月</span>
                        <span>日</span>
                        <span>时</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 4. 记录数据列表 -->
        <record-virtual-list
            v-bind:gotData="gotRecordRecentlyData"
            v-bind:recordList="recordList">
        </record-virtual-list>

        <!-- 4.1 空数据组件 -->
        <no-data
            v-if="noRecordData"
            v-bind:noteText="'记录空空如也~'"
            v-bind:showButton="true"
            v-bind:buttonText="'马上起盘'"
            v-bind:buttonFunc="clickStartCollate">
        </no-data>

        <!-- 5. 字母索引表 -->
        <letter-side-bar 
            v-show="gotRecordData && recordCurOrderIndex == 1">
        </letter-side-bar>
  
        <router-view></router-view>
    </div>
</template>

<script>
import NoData from '../components/common/NoData.vue'
import RecordTopBar from '../layouts/record/RecordTopBar.vue'
import RecordVirtualList from '../layouts/record/RecordVirtualList.vue'
import LetterSideBar from '../layouts/record/LetterSideBar.vue'
import { RECORD_DATA_MANAGER } from '../modules/data';
import { RECORD_DOM } from '../modules/dom'
export default {
    name : 'Record',
    components: { NoData, RecordTopBar, RecordVirtualList, LetterSideBar },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        gotRecordRecentlyData() {
            return this.$store.state.record.gotRecordRecentlyData;
        },
        noRecordData() {
            return this.$store.state.record.noRecordData;
        },
        recordCurOrderIndex() {
            return this.$store.state.record.recordCurOrderIndex;
        },
        recordList() {
            return this.$store.state.record.recordListData;
        },
        showAllRecord() {
            return this.$store.state.allrecord.showAllRecord;
        },
        curFilterData() {
            return this.$store.state.allrecord.curFilterData;
        },
        scrollToIndex() {
            return this.$store.state.recordletter.scrollToIndex;
        },
        recordCurFirstL() {
            return this.$store.state.recordletter.recordCurFirstL;
        }
    },
    data(){
        return {
            createTimeOrder: 1, // 0 为默认的降序（最新的在最上）箭头向上，1为转换的升序箭头乡下
        }
    },
    mounted: function() {
        // 设置样式
        setTimeout(() => {
            if(this.recordCurOrderIndex == 1) {
                RECORD_DOM.resetRecordLetterSideBarStyle('record');
            }
        }, 20);

        setTimeout(() => {
            RECORD_DOM.resetRecordListContentStyle();
        }, 500);

        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }

        // 加载完成后,静默全局的基础数据
        this.$store.dispatch('initBasicData');

        var me = this;
        setTimeout(() => {
            me.$store.dispatch('reminder/checkReportAIStatus');
        }, 2000);
    },
    created: function() {
        if(!this.gotRecordRecentlyData){
            this.$store.dispatch('record/initRecordRecentlyList');
        }
    },
    methods:{
        clickAll() {
            this.$router.replace('/record/all')
        },
        clickNameOrder() {
            // if(this.recordCurOrderIndex != 1){
                this.$store.dispatch('allrecord/filterAllRecordList');
                this.$store.state.record.recordCurOrderIndex = 1;
                this.$bus.emit('updateScrollToTop')
                RECORD_DOM.updateRecordListStyle();
                RECORD_DOM.resetRecordListContentStyle();
                RECORD_DOM.resetRecordLetterSideBarStyle('record');
            // }
        },
        clickCreateTime() {
            if(this.recordCurOrderIndex == 2){
                this.createTimeOrder = this.createTimeOrder == 0 ? 1 : 0;
            }else{
                this.createTimeOrder = 1;
            }
            this.$store.state.record.recordCurOrderIndex = 2;
            this.$store.dispatch('record/filterOtherRecordList', {
                type: 'createtime',
                value: this.createTimeOrder
            });
            this.$bus.emit('updateScrollToTop')
            RECORD_DOM.updateRecordListStyle();
            RECORD_DOM.resetRecordListContentStyle();
        },
        clickRecent() {
            if(this.recordCurOrderIndex != 3) {
                this.$store.state.record.recordCurOrderIndex = 3;
                this.$store.dispatch('record/filterOtherRecordList', {
                    type: 'recent',
                    value: 0
                });
                this.$bus.emit('updateScrollToTop')
                RECORD_DOM.updateRecordListStyle();
                RECORD_DOM.resetRecordListContentStyle();
            }
        },
        clickRecordItem(recordData) {
            var personInfo = this.$store.state.record.recordOriginalData[recordData.id];
            this.$store.dispatch('detail/initDetail', personInfo);
            // 更新列表数据
            AppFate.$store.dispatch('record/updateRecordListData', personInfo);
            this.$router.replace('/detail/record/'+ personInfo.id);
        },
        clickStartCollate() {
            this.$router.replace('/collate');
        }
    }
}
</script>
